import { useQuery } from '@tanstack/react-query';
import OaiApiClient from '../clients/oai-api/oai-api-client';
import { queryClient } from '../query-client';

type Params = {
  symbol?: string;
};

export const ensureChainSummary = async ({ symbol }: Params) => {
  return await queryClient.ensureQueryData({
    queryKey: ['chain-summary', symbol],
    queryFn: () => {
      if (!symbol) {
        throw new Error('Symbol is required for chain summary');
      }

      return OaiApiClient.getChainSummary(symbol);
    },
  });
};

export const useChainSummary = ({ symbol }: Params) => {
  return useQuery({
    queryKey: ['chain-summary', symbol],
    queryFn: async () => {
      if (!symbol) {
        throw new Error('Symbol is required');
      }

      return OaiApiClient.getChainSummary(symbol);
    },
    staleTime: 1000 * 60,
    enabled: !!symbol,
  });
};

export const prefetchChainSummary = (symbol: string) => {
  return queryClient.prefetchQuery({
    queryKey: ['chain-summary', symbol],
    queryFn: async () => {
      return OaiApiClient.getChainSummary(symbol);
    },
  });
};
